import sortBy from 'lodash/sortBy';
import moment from 'moment-timezone';
import { createSelector } from 'reselect';
import { fromNowOrNow } from 'utils/fromNowOrNow';
/**
 * Helper function to get notification type as the second argument when using
 * selectors.
 */
const selectType = (_, type) => type;
export const getNotificationsState = (state) => state.notifications;
/** Selects current notifications. */
export const selectCurrentNotifications = (state) => getNotificationsState(state).currentNotifications;
export const getNotificationsHistory = (state) => getNotificationsState(state).notificationsHistory;
export const getPersistedNotifications = (state) => getNotificationsState(state).persistedNotifications;
const transformPersistedNotification = (p) => {
    const { data: { params }, } = p;
    const notification = {
        title: p.data.params.subject,
        text: '',
        subText: fromNowOrNow(moment(p.createdAt)),
        icon: 'sync',
        status: 'default',
    };
    if (params.notification_type === 'BulkActionSucceeded') {
        notification.icon = 'done';
        notification.status = 'success';
    }
    else if (params.notification_type === 'BulkActionFailed') {
        notification.status = 'danger';
        notification.icon = 'exclamation';
    }
    else if (params.notification_type === 'BulkActionPartialFailed') {
        notification.status = 'warning';
        notification.icon = 'exclamation';
    }
    return {
        type: 'persisted',
        id: p.notificationId,
        data: notification,
        timestamp: new Date(p.createdAt).getTime(),
        message: p.data.params.message,
        bulkId: p.data.params.bulk_id,
        bulkStatus: params.notification_type,
    };
};
const transformLocalNotification = (notification) => {
    return {
        type: 'local',
        id: notification.id,
        data: Object.assign(Object.assign({}, notification), { text: '', subText: fromNowOrNow(moment(notification.timestamp)) }),
        timestamp: new Date(notification.timestamp).getTime(),
        bulkId: null,
        bulkStatus: null,
    };
};
export const getAllNotificationHistory = createSelector([getNotificationsHistory, getPersistedNotifications], (notificationsHistory, persistedNotifications) => {
    const persisted = persistedNotifications.map(transformPersistedNotification);
    const local = notificationsHistory.map(transformLocalNotification);
    return sortBy([...local, ...persisted], ['timestamp']).reverse();
});
/** Selects current notifications having given type. */
export const selectCurrentNotificationsByType = createSelector([selectCurrentNotifications, selectType], (notifications, type) => notifications.filter((notification) => notification.type === type));
